import React from 'react';
import AppLinks from './AppLinks';

const AppLinker = ({ showDetail = true, topSpacing = "200px", title = "Trade Smarter with ToyTrade App" }) => {
    return (
        <div style={{ textAlign: 'start' }}>
            {topSpacing && <div className="d-none d-md-block" style={{ height: topSpacing }}>&nbsp;</div>}
            <h2 className="fw-bold">{title}</h2>
            {showDetail && (
                <>
                    <p className="fs-4">Discover new Toys, chat with People like you and trade your pre-loved toys</p>

                </>
            )}
            <p className="fs-5">Download the app now and start trading</p>
            <AppLinks />
        </div>
    );
};

export default AppLinker;
